
<div class="pd">
    <div class="delete-container bg-danger" nz-row>
    <nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="23" nzXl="23">
        <h3 class="waec-card-header-text mb-3">
          <span>
              <img
              [src]="urls.WARNING_ICON"
              class="svg-icon"
              alt=""
              />
          </span>
          {{'PROFILE.DELETE-ACCOUNT.DELETION_OF_ACCOUNT' | translate}}
        </h3>

        <div class="span-left">
        <p>{{'PROFILE.DELETE-ACCOUNT.WARNING_PROMPT' | translate}}</p>
        <ul class="article">
            <li>
            {{'PROFILE.DELETE-ACCOUNT.ERASURE_NOTE' | translate}}
            </li>
            <br />
            <li>
           {{'PROFILE.DELETE-ACCOUNT.ACCOUNT_VALIDITY' | translate}}
            </li>
            <br />
            <li>
            {{'PROFILE.DELETE-ACCOUNT.ACCOUNT_RIGHT' | translate}}
            </li>
            <br />
            <li>
            {{'PROFILE.DELETE-ACCOUNT.PREVIOUS_INFORMATION' | translate}}
            </li>
            <br />
            
        </ul>
        </div>
    </nz-col>
    <nz-col [nzSpan]="24">
        <label
        #option
        nz-checkbox
        class="confirm_delete"
        [(ngModel)]="isChecked"
        (ngModelChange)="checkButton($event)"
        >
        {{'PROFILE.DELETE-ACCOUNT.CONFIRM_DELETE' | translate}}</label>
    </nz-col>
    <nz-col
        [nzSm]="24"
        [nzXs]="24"
        [nzMd]="8"
        [nzLg]="8"
        [nzXl]="6"
        [nzXXl]="4"
    >
        <button
        nz-button
        class="v2-btn-primary"
        [nzType]="'primary'"
        [nzLoading]="loading"
        [disabled]="!isDisabled"
        (click)="onDelete()"
        nzBlock
        >
        {{'PROFILE.DELETE_ACCOUNT' | translate | uppercase}}
        </button>
    </nz-col>
    </div>
</div> 

<!-- ACCOUNT DELETE REASON MODAL -->
<nz-modal
  [(nzVisible)]="isDeleteReason"
  [nzFooter]="modalFooter"
  [nzMask]="true"
  nzWidth="650px"
  nzClassName="delete-account-modal"
  nzCentered="true"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleDeleteReasonModalCancel()"
>
  <ng-container *nzModalContent>
    <nz-row>
      <form [formGroup]="deleteReasonForm" class="w-100">
        <nz-form-item>
          <nz-form-control nzErrorTip="Please select reason">
            <nz-form-label 
              [nzNoColon]="true"
              nzRequired 
              nzFor="delete_reason_id"
            > 
              {{'PROFILE.DELETE-ACCOUNT.REASON_PROMPT' | translate}} {{deleteType === deleteTypes.DEACTIVATE ? ('PROFILE.DELETE-ACCOUNT.DEACTIVATING' | translate) : ('PROFILE.DELETE-ACCOUNT.DELETING' | translate)}} {{'PROFILE.DELETE-ACCOUNT.YOUR_ACCOUNT' | translate | lowercase}}?
            </nz-form-label>
  
            <nz-select 
              nzPlaceHolder="{{'PROFILE.DELETE-ACCOUNT.SELECT_REASON_TO' | translate}} {{deleteType === deleteTypes.DEACTIVATE ? ('PROFILE.DELETE-ACCOUNT.DEACTIVATE' | translate | lowercase) : ('PROFILE.DELETE-ACCOUNT.DELETE' | translate | lowercase)}} {{'PROFILE.DELETE-ACCOUNT.ACCOUNT' | translate}}"
              formControlName="delete_reason_id"
              (ngModelChange)="isSelectedReasonOther($event)"
            >
              <nz-option 
                *ngFor="let option of deleteAccountReasons"
                [nzLabel]="option?.name" 
                [nzValue]="option?.id"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
  
        <nz-form-item>
          <nz-form-control nzErrorTip="{{'PROFILE.DELETE-ACCOUNT.REASON_ERROR' | translate}} {{ deleteType === deleteTypes.DEACTIVATE ? ('PROFILE.DELETE-ACCOUNT.DEACTIVATE' | translate | lowercase) : ('PROFILE.DELETE-ACCOUNT.DELETE' | translate | lowercase)}} {{'PROFILE.DELETE-ACCOUNT.ACCOUNT' | translate}}">
            <nz-form-label 
              [nzNoColon]="true"
              [nzRequired]="isRequired"
              nzFor="delete_note"
            > 
              {{'PROFILE.DELETE-ACCOUNT.IMPROVE_PROMPT' | translate}}
            </nz-form-label>
  
            <textarea
              nz-input
              formControlName="delete_note"
              [nzAutosize]="{ minRows: 3, maxRows: 6 }"
            ></textarea>
  
          </nz-form-control>
        </nz-form-item>
  
      </form>
    </nz-row>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="secondary" class="cancel-btn" (click)="handleDeleteReasonModalCancel()">
      {{'GENERAL.CANCEL' | translate | uppercase}}
    </button>

    <button nz-button nzType="primary" class="delete-btn"  (click)="onDeleteReason()">{{deleteType === deleteTypes.DEACTIVATE ? ('PROFILE.DELETE-ACCOUNT.DEACTIVATE' | translate) : 'PROFILE.DELETE-ACCOUNT.DELETE' | translate}} {{'PROFILE.DELETE-ACCOUNT.ACCOUNT' | translate | uppercase}}</button>
  </ng-template>
</nz-modal>

<!-- DELETE OPTIONS MODAL -->
 <nz-modal
  [(nzVisible)]="showDeleteOptions"
  [nzFooter]="null"
  [nzMask]="true"
  nzWidth="600px"
  nzCentered="true"
  nzClassName="delete-options-modal"
  nzMaskClosable="false"
  nzClosable="false"
 >
    <ng-container *nzModalContent>
      <nz-row class="header">
        <nz-col nzSpan="2">
          <img class="mt-1" [src]="urls.SAD" alt="">
        </nz-col>
        <nz-col nzSpan="21" class="px-3">
          <p class="title">{{'PROFILE.DELETE-ACCOUNT.HATE_TO_SEE' | translate}}</p>
          <p class="mt-1">{{'PROFILE.DELETE-ACCOUNT.ALTERNATIVES' | translate}}</p>
        </nz-col>
      </nz-row>

      <div class="content-area">
        <nz-row (click)="speakToSupport()" class="panel">
          <nz-col nzSpan="2">
            <img [src]="urls.SUPPORT_GREEN" alt="">
          </nz-col>
          <nz-col nzSpan="21" class="content">
            <p class="title">{{'PROFILE.DELETE-ACCOUNT.HATE_TO_SEE' | translate}}</p>
            <p class="mt-1 text">{{'PROFILE.DELETE-ACCOUNT.SUPPORT_MODAL_DESC' | translate}}</p>
          </nz-col>
        </nz-row>

         <nz-row (click)="displayTempDeleteModal()" class="panel mt-3">
          <nz-col nzSpan="2">
            <img [src]="urls.PAUSE" alt="">
          </nz-col>
          <nz-col nzSpan="21" class="content">
            <p class="title">{{'PROFILE.DELETE-ACCOUNT.TEMP_DEACTIVATE' | translate}}</p>
            <p class="mt-1 text">{{'PROFILE.DELETE-ACCOUNT.TEMP_MODAL_DESC' | translate}}</p>
          </nz-col>
        </nz-row>

        <div class="text-center mt-5">
          <p>{{"GENERAL.OR" | translate}}</p>
          <button (click)="closeDeleteOptionsModal()" class="btn-clear mt-3 mx-auto">{{'PROFILE.DELETE-ACCOUNT.KEEP_ACTIVE' | translate}}</button>
          <p (click)="showDeleteReasonModal(deleteTypes.DELETE)" class="mt-6 mx-auto permanent-delete-text">{{'PROFILE.DELETE-ACCOUNT.PERMANENTLY_DELETE' | translate}}</p>
        </div>
        

        <div>

        </div>
      </div>
    </ng-container>
  </nz-modal>

<!-- TEMPORARY DELETE MODAL -->
 <nz-modal
  [(nzVisible)]="showTempDeleteModal"
  [nzFooter]="null"
  [nzMask]="true"
  nzWidth="664px"
  nzCentered="true"
  nzClassName="delete-options-modal"
  nzMaskClosable="false"
  nzClosable="false"
 >
  <ng-container *nzModalContent>
    <nz-row class="pt-3 tmp-delete-modal-content">
      <nz-col nzXs="24" nzSm="2" class="justify-between">
        <img class="mt-1 pause" [src]="urls.PAUSE" alt="">
        <img class="close-btn-mobile" [src]="urls.CANCEL" (click)="closeTempDeleteModal()" alt="">
      </nz-col>
      <nz-col nzXs="24" nzSm="21">
        <div class="justify-between">
          <span class="title mt-2">{{'PROFILE.DELETE-ACCOUNT.TEMP_DEACTIVATE' | translate}}</span>
          <img class="close-btn" [src]="urls.CANCEL" (click)="closeTempDeleteModal()" alt="">
        </div>

        <nz-col nzXs="24" nzLg="16" class="mt-3">
          <p class="subtitle">{{'PROFILE.DELETE-ACCOUNT.TAKE_A_BREAK' | translate}}</p>
        </nz-col>

        <nz-col nzXs="24" nzLg="22" class="mt-6"> 
          <div class="info-panel">
            <p class="heading">{{'PROFILE.DELETE-ACCOUNT.DEACTIVATE_MODAL_HEADING' | translate}}</p>
            <ul>
              @for(item of deactivationInstructions; track $index) {
                <li [innerHTML]="item | translate"></li>
              }
            </ul>
          </div>
        </nz-col>
      </nz-col>
    </nz-row>

    <nz-row class="foot">
      <nz-col nzSpan="24" class="btn-wrapper">
        <button (click)="goBack()" class="btn-clear">{{'GENERAL.GO_BACK' | translate}}</button>
        <button  (click)="showDeleteReasonModal(deleteTypes.DEACTIVATE)" nz-button [nzType]="'primary'" class="btn-primary">{{'PROFILE.DELETE-ACCOUNT.DEACTIVATE_ACCOUNT' | translate}}</button>
      </nz-col>
    </nz-row>
  </ng-container>
</nz-modal>

<!-- CONFIRM DELETE MODAL -->
<nz-modal
  [(nzVisible)]="isConfirmDelete"
  [nzFooter]="confirmDeletemodalFooter"
  [nzMask]="true"
  nzWidth="410px"
  nzCentered="true"
  nzClassName="confirm-delete-modal"
  nzMaskClosable="false"
  nzClosable="false"
  (nzOnCancel)="handleConfirmDeleteModalCancel()"
>
  <ng-container *nzModalContent>

    <nz-row nz-title>
      <h3 class="waec-card-header-text mb-3">
        <span>
          <img [src]="urls.WARNING_ICON" class="svg-icon" alt=""/>
        </span>
        <span> {{deleteType === deleteTypes.DEACTIVATE ? ('PROFILE.DELETE-ACCOUNT.DEACTIVATE' | translate) : 'PROFILE.DELETE-ACCOUNT.DELETE' | translate}} {{'PROFILE.DELETE-ACCOUNT.YOUR_ACCOUNT' | translate}}</span>
      </h3>
    </nz-row>
  
    <nz-row>
      @if(user?.type === userTypes.VERIFIER) {
        @if(deleteType === deleteTypes.DELETE) {
          <p>
            {{'PROFILE.DELETE-ACCOUNT.CONFIRM_VERIFIER_MESSAGE' | translate}}
          </p>
        }
        @if(deleteType === deleteTypes.DEACTIVATE) {
           <p>
            {{'PROFILE.DELETE-ACCOUNT.KINDLY_NOTE_DEACTIVATE' | translate}}
          </p>
        }
      } @else {
        @if(deleteType === deleteTypes.DELETE) {
          <p>
           {{'PROFILE.DELETE-ACCOUNT.KINDLY_NOTE_DELETE' | translate}}
          </p>
        }
        @if(deleteType === deleteTypes.DEACTIVATE) {
           <p>
            {{'PROFILE.DELETE-ACCOUNT.KINDLY_NOTE_DEACTIVATE' | translate}}
          </p>
        }
      }
    </nz-row>
  </ng-container>

  <ng-template #confirmDeletemodalFooter>
    <button [disabled]="updatingAccountStatus" nz-button nzType="secondary" class="cancel"  (click)="handleConfirmDeleteModalCancel()">
      {{'GENERAL.CANCEL' | translate}}
    </button>

    <button nz-button [disabled]="updatingAccountStatus" nzType="primary" class="confirm-delete-btn" (click)="deleteType === deleteTypes.DEACTIVATE ? onConfirmDeactivate() : onConfirmDelete()">{{'GENERAL.YES' | translate | uppercase}}</button>
  </ng-template>
</nz-modal>
